export { default } from './UnscoredTableSkeleton'
